import axios from "axios";
import tables from "../../models/tables/tables";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getTables() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/unnegocios/tablas`, { headers }).then(({ data }) =>
      data.map((item) => {
        return tables.fromJson(item);
      })
    );
  }
}
export default service;
